import { GetOfficialCompetitions as GetOfficialCompetitionsAction } from "../../providers/supabase-provider/actions/GetOfficialCompetitions";
import type { ICompetitionView } from "../../entities";

export const GetOfficialCompetitions = async (): Promise<ICompetitionView[]> => {
  return await GetOfficialCompetitionsAction();
};
